import { Avatar, Box, Button, Grid, makeStyles, Typography, TextField, Select, MenuItem } from '@material-ui/core'
import React, { useState } from 'react'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomInput from '../CustomInput'
import CustomLabel from '../CustomLabel'
import CustomSelect from '../CustomSelect'
import CustomTabAndContent from '../CustomTabAndContent'
import ProductCatalogueForm from '../Forms/ProductCatalogue/ProductCatalogueForm'
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import BusinessConfig1 from './BusinessConfig1'
const useStyles = makeStyles((theme) => ({
  avatar: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    // margin: '0px auto',
    marginLeft: '20px',
  },
  button: {
    // margin: '0px auto',
    marginLeft: '52px',
    display: 'flex',
    textTransform: 'none',
  },
  select: { width: '163px', marginTop: '5px', padding: '5px', border: 'none', backgroundColor: '#EFF3FE' },
  label: { margin: '10px 10px', fontSize: '18px' },
}))

export default function BusinessConfiguration({ admin }) {
  const classes = useStyles()
  const [companyName, setCompanyName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [totalEmployee, setTotalEmployee] = useState('')
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [domain, setDomain] = useState('')
  const [image, setImage] = useState('')
  const [imagePreview, setImagePreview] = useState('')
  const [imageUploaded, setImageUploaded] = useState('')
  const { updateCompanyAdmin, updateCompanyAdminSetting } = useCompanyAdmin()
  const [Language, setLanguage] = useState(null)
  const [Currency, setCurrency] = useState(null)
  const [TimeZone, setTimeZone] = useState(null)
  const [FinancialYear, setFinancialYear] = useState(null)
  const [WorkingDays, setWorkingDays] = useState({ from: '', to: '' })
  const [ReportingTime, setReportingTime] = useState(null)
  const [ReleavingTime, setReleavingTime] = useState()

  const BasicDetail = () => {
    const [open, setOpen] = useState(false)
    //console.log()
    const inputs = [
      { label: 'Company Name', value: companyName, handleChange: setCompanyName },
      { label: 'First Name', value: firstName, handleChange: setFirstName },
      { label: 'Last Name', value: lastName, handleChange: setLastName },
      { label: 'Number of Employees', value: totalEmployee, handleChange: setTotalEmployee },
      { label: 'Email', value: email, handleChange: setEmail },
      { label: 'Domain', value: domain, handleChange: setDomain },
    ]

    const handleImage = async (event) => {
      setImage(event.target.files[0])
      if (event.target.files && event.target.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          setImagePreview(e.target.result)
          setImageUploaded(true)
        }
        reader.readAsDataURL(event.target.files[0])
      }
    }

    const handleSubmit = () => {
      updateCompanyAdmin({
        name: companyName,
        phoneNUmber: mobile,
        firstName,
        lastName,
        email,
        employeeCount: totalEmployee,
        domain,
      })
    }

    return (
      <>
        {/* <CustomDialog open={open} handleClose={() => setOpen(false)}>
          <ProductCatalogueForm handleClose={() => setOpen(false)} />
        </CustomDialog> */}
        <Grid container>
          <Grid item lg={3} container>
            {imagePreview && imageUploaded ? <Avatar src={imagePreview} className={classes.avatar} /> : <Avatar className={classes.avatar} />}

            <br />
            {/* <input
              accept="image/*"
              style={{ display: 'none' }}
              id="contained-button-file"
              multiple
              type="file"
              onChange={handleImage}
            />
            <label htmlFor="contained-button-file">
              <Button variant="contained" color="primary" component="span" className={classes.button}>
                Browse Image
              </Button>
            </label>
            <br />
            <br /> */}
            {/* <Button
              variant="contained"
              color="primary"
              component="span"
              className={classes.button}
              onClick={() => setOpen(true)}
            >
              Product Catalogue
            </Button> */}
            {/* </label> */}

            <Grid item lg={12}>
              <div style={{ marginTop: '47px' }}>
                <Typography>Phone Number</Typography>
                <TextField id="standard-basic" label="" />
              </div>
            </Grid>
          </Grid>
          <Grid item lg={1} />
          <Grid item lg={8}>
            <Grid container spacing={2}>
              {inputs.map((item, index) => (
                <Grid item lg={6} key={index}>
                  {/* <CustomInput label={item.label} value={item.value} handleChange={item.handleChange} />
                  <br /> */}

                  <Typography>{item.label}</Typography>
                  <TextField id="standard-basic" label="" />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {/* <Box textAlign="end" marginTop="10px">
          <CustomButton text="Save" handleSubmit={handleSubmit} />
        </Box> */}
        <Grid lg={12} container spacing={2} style={{ marginTop: '40px' }}>
          <Grid item lg={4}>
            <Button variant="contained" color="primary" fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid item lg={4}>
            <Button variant="contained" color="primary" fullWidth>
              Save
            </Button>
          </Grid>
        </Grid>
      </>
    )
  }

  const Settings = () => {
    const settings = [
      { label: 'Language', to: [{ label: 'Language' }] },
      { label: 'Currency', to: [{ label: 'Currency' }] },
      { label: 'Timezone', to: [{ label: 'Timezone' }] },
      { label: 'Financial Year', to: [{ label: 'Financial Month' }] },
      { label: 'Working Days', from: [{ label: 'From' }], to: [{ label: 'To' }] },
      { label: 'Reporting Time' },
      { label: 'Releaving Time', from: [{ label: 'From' }], to: [{ label: 'To' }] },
      { label: 'Holiday', from: [{ label: 'From' }], to: [{ label: 'To' }] },
    ]
    return (
      <>
        {/* {settings.map((item, index) => (
          <Grid conatiner style={{ display: 'flex' }}>
            <Grid item lg={4}>
              <CustomLabel label={item.label} />{' '}
            </Grid>

            <Grid item lg={5}>
              <Box display="flex">
                {item.from ? (
                  <>
                    <select
                      variant="outlined"
                      name=""
                      id=""
                      onChange={(e) => item.handleChange(e.target.value)}
                      value={item.value}
                      className={classes.select}
                      placeholder={item.label}
                    >
                      <option value=""> {item.label}</option>
                    </select>
                    <CustomLabel label="To" className={classes.label} />
                  </>
                ) : (
                  <div style={{ visibility: 'hidden', width: '200px' }} />
                )}
                <select
                  variant="outlined"
                  name=""
                  id=""
                  onChange={(e) => item.handleChange(e.target.value)}
                  value={item.value}
                  className={classes.select}
                  placeholder={item.label}
                >
                  <option value=""> {item.label}</option>
                </select>
              </Box>
            </Grid>
            <br />
            <br />
          </Grid>
        ))}

        <Box textAlign="start" marginTop="10px">
          <CustomButton text="Save" />
        </Box> */}
        <Grid container lg={12} spacing={4}>
          {settings.map((item, index) => (
            <Grid item lg={4}>
              <Typography>{item.label}</Typography>
              {item.from ? (
                <div style={{ display: 'flex', justifyContent: 'stretch' }}>
                  <Select labelId="demo-simple-select-label" id="demo-simple-select" value={item.value} onChange={item.handleChange} style={{ width: '25%' }}>
                    <MenuItem value={10}>Dummy</MenuItem>
                    <MenuItem value={20}>Dummy</MenuItem>
                    <MenuItem value={30}>Dummy</MenuItem>
                  </Select>
                  <Typography>To</Typography>
                  <Select labelId="demo-simple-select-label" id="demo-simple-select" value={item.value} onChange={item.handleChange} style={{ width: '25%' }}>
                    <MenuItem value={10}>Dummy</MenuItem>
                    <MenuItem value={20}>Dummy</MenuItem>
                    <MenuItem value={30}>Dummy</MenuItem>
                  </Select>
                </div>
              ) : item.to ? (
                <div>
                  <Select labelId="demo-simple-select-label" id="demo-simple-select" value={item.value} onChange={item.handleChange} style={{ width: '54%' }}>
                    <MenuItem value={10}>Dummy</MenuItem>
                    <MenuItem value={20}>Dummy</MenuItem>
                    <MenuItem value={30}>Dummy</MenuItem>
                  </Select>
                </div>
              ) : (
                <div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardTimePicker
                      id="time-picker"
                      style={{ width: '55%' }}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              )}
            </Grid>
          ))}
        </Grid>
      </>
    )
  }

  const Privacy = () => {
    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography>Who can add employees to your company</Typography>
          </Grid>
          <Grid item xs={6}>
            <select variant="outlined" name="" id="">
              <option value="">Onlyme</option>
              <option value="">Supervisor</option>
            </select>
          </Grid>
          <Grid item xs={6}>
            <Typography> Who can upload and download bulk data</Typography>
          </Grid>
          <Grid item xs={6}>
            <select variant="outlined" name="" id="">
              <option value="">Onlyme</option>
              <option value="">Supervisor</option>
            </select>
          </Grid>
          <Grid item xs={6}>
            <Typography> Who can change the Attendance of employee</Typography>
          </Grid>
          <Grid item xs={6}>
            <select variant="outlined" name="" id="">
              <option value="">Onlyme</option>
              <option value="">Supervisor</option>
            </select>
          </Grid>
          <Grid item xs={6}>
            <Typography> Who can change the status of lead</Typography>
          </Grid>
          <Grid item xs={6}>
            <select variant="outlined" name="" id="">
              <option value="">Onlyme</option>
              <option value="">Supervisor</option>
            </select>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <div>
      <CustomTabAndContent tab1="Basic Information" tab2="Account Settings" tab3="Privacy" content1={<BasicDetail />} content2={<Settings />} content3={<Privacy />} />
    </div>
  )
}
